import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, Box, Typography, Avatar, IconButton, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FiX, FiUser } from 'react-icons/fi';
import Like from '../../assets/static_images/like.svg';
import Love from '../../assets/static_images/love.svg';
import Haha from '../../assets/static_images/haha.svg';
import Wow from '../../assets/static_images/wow.svg';
import Sad from '../../assets/static_images/sad.svg';
import Angry from '../../assets/static_images/angry.svg';
import axios from 'lib/axios';
import ReactViewProfile from './ReactViewProfile';

const ViewReactModal = ({ setOpenModal, openModal, post = {}, type, endpoint }) => {
    const [activeTab, setActiveTab] = useState(0);
    const [allCount, setAllCount] = useState(0);
    const [reactTab, setReactTab] = useState([]);
    const [reactss, setReacts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [profileLoading, setProfileLoading] = useState(false);
    const [reactCategory, setReactCategory] = useState(null);
    const [viewProfile, setViewProfile] = useState(false);
    const [userProfileData, setUserProfileDate] = useState({});

    const theme = useTheme();
    const matchesXs = useMediaQuery((theme) => theme.breakpoints.down('md'));

    const reacts = [
        { react_id: 1, react_name: 'Like', icon: Like },
        { react_id: 2, react_name: 'Love', icon: Love },
        { react_id: 3, react_name: 'Haha', icon: Haha },
        { react_id: 4, react_name: 'Wow', icon: Wow },
        { react_id: 5, react_name: 'Sad', icon: Sad },
        { react_id: 6, react_name: 'Angry', icon: Angry }
    ];

    const findReact = (id) => {
        switch (id) {
            case 1:
                return Like;
            case 2:
                return Love;
            case 3:
                return Haha;
            case 4:
                return Wow;
            case 5:
                return Sad;
            case 6:
                return Angry;
            default:
                return null;
        }
    };

    const fetchReacts = async () => {
        const requestBody = {
            offset: 0,
            limit: 10,
            react_id: reactCategory,
            comment_id: post?.comment_id
        };
        if (type === 'news') {
            requestBody.news_id = post.news_id;
        } else if (type === 'post') {
            requestBody.post_id = post.post_id;
        } else if (type === 'notice') {
            requestBody.notice_id = post.notice_id;
        } else if (type === 'event') {
            requestBody.event_id = post.event_id;
        } else if (type === 'reward') {
            requestBody.reward_id = post.reward_id;
        } else if (type === 'policy') {
            requestBody.policy_id = post.policy_id;
        } else {
            requestBody.post_id = post.post_id;
        }
        try {
            setIsLoading(true);

            const res = await axios.post(endpoint, requestBody);

            if (res.data.success) {
                if (reactTab.length == 0) {
                    setReactTab(res.data.reacts_smmary);
                }
                if (allCount == 0) {
                    setAllCount(res.data.reacts?.length);
                }

                if (type === 'reward' || type === 'policy') {
                    setReacts(res.data.reacts);
                } else {
                    setReacts(res.data.reacts);
                }

                setIsLoading(false);
            }
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        }
    };

    async function fetchUserData(id) {
        setProfileLoading(true);
        await axios
            .post(`/users/user`, {
                id: id
            })
            .then(({ data }) => {
                if (data) {
                    console.log('data--------', data.data);
                    setUserProfileDate(data.data);
                    setViewProfile(true);
                    setProfileLoading(false);
                }
            })
            .catch((err) => {
                setProfileLoading(false);
                console.log(err);
            });
    }

    useEffect(() => {
        fetchReacts();
    }, [reactCategory, post]);

    // Create tabs data
    const tabs = [
        {
            label: 'All',
            count: allCount,
            icon: null,
            react_id: null
        },
        ...reactTab
            .filter((react) => react.count > 0)
            .map((react) => ({
                label: react.react_name,
                count: react.count,
                icon: findReact(react.react_id),
                react_id: react.react_id
            }))
    ];

    // Get current users to display
    const getCurrentUsers = () => {
        if (activeTab === 0) {
            return reactss;
        }

        const selectedTab = tabs[activeTab];
        if (!selectedTab || !selectedTab.react_id) {
            return [];
        }

        return reactss.filter((user) => user.react_id === selectedTab.react_id) || [];
    };

    const currentUsers = getCurrentUsers();

    const handleTabChange = (tabIndex) => {
        setActiveTab(tabIndex);
        if (tabIndex === 0) {
            setReactCategory(null);
        } else {
            setReactCategory(tabs[tabIndex].react_id);
        }
    };

    const UserCard = ({ userReaction }) => {
        // Safety check
        if (!userReaction || !userReaction.user) {
            return null;
        }

        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    p: 2,
                    borderRadius: '8px',
                    border: '1px solid #e9ecef',
                    backgroundColor: '#fff',
                    transition: 'background-color 0.2s ease',
                    '&:hover': {
                        backgroundColor: '#f8f9fa'
                    }
                }}
            >
                <Box sx={{ position: 'relative' }}>
                    <Avatar
                        src={userReaction.user?.profile_image}
                        sx={{
                            width: 40,
                            height: 40,
                            border: '1px solid #e9ecef'
                        }}
                    >
                        {userReaction.user ? (
                            `${userReaction.user.first_name} ${userReaction.user.last_name}`.charAt(0)
                        ) : (
                            <FiUser size={20} />
                        )}
                    </Avatar>

                    {/* Reaction indicator */}
                    {userReaction.react_id && (
                        <Box
                            sx={{
                                position: 'absolute',
                                bottom: -2,
                                right: -2,
                                width: 20,
                                height: 20,
                                borderRadius: '50%',
                                backgroundColor: '#fff',
                                border: '1px solid #e9ecef',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <img src={findReact(userReaction.react_id)} alt="reaction" style={{ width: '12px', height: '12px' }} />
                        </Box>
                    )}
                </Box>

                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontWeight: 600,
                            fontSize: '0.95rem',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {userReaction.user ? `${userReaction.user.first_name} ${userReaction.user.last_name}` : 'Unknown User'}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
                        {userReaction.user?.job_title?.[0]?.title || 'No designation'}
                    </Typography>
                </Box>

                <Box>
                    <Typography
                        variant="caption"
                        sx={{
                            color: '#1E7C88',
                            fontWeight: 500,
                            fontSize: '0.75rem'
                        }}
                    >
                        {reacts.find((r) => r.react_id === userReaction.react_id)?.react_name || 'Reacted'}
                    </Typography>
                </Box>
            </Box>
        );
    };

    return (
        <>
            <Dialog
                open={openModal}
                onClose={() => setOpenModal(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        maxHeight: '80vh',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        border: '1px solid #e9ecef'
                    }
                }}
            >
                {/* Header */}
                <DialogTitle
                    sx={{
                        pb: 2,
                        borderBottom: '1px solid #e9ecef',
                        backgroundColor: '#fff',
                        position: 'relative'
                    }}
                >
                    <Box sx={{ pr: 6 }}>
                        <Typography variant="h6" sx={{ fontWeight: 600, color: '#1E7C88' }}>
                            Reactions
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {allCount} {allCount === 1 ? 'person' : 'people'} reacted
                        </Typography>
                    </Box>
                    <IconButton
                        onClick={() => setOpenModal(false)}
                        sx={{
                            position: 'absolute',
                            right: 16,
                            top: 16,
                            color: 'text.secondary',
                            bgcolor: 'grey.100',
                            borderRadius: '50%',
                            '&:hover': { bgcolor: 'grey.300' },
                            zIndex: 2
                        }}
                        size="small"
                    >
                        <FiX size={18} />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ p: 0 }}>
                    {/* Tabs */}
                    <Box sx={{ px: 2, py: 1, borderBottom: '1px solid #f0f0f0' }}>
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 1,
                                overflowX: 'auto',
                                pb: 1,
                                '&::-webkit-scrollbar': {
                                    height: '4px'
                                },
                                '&::-webkit-scrollbar-track': {
                                    backgroundColor: '#f1f1f1',
                                    borderRadius: '4px'
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    backgroundColor: '#ccc',
                                    borderRadius: '4px'
                                }
                            }}
                        >
                            {tabs.map((tab, index) => (
                                <Box
                                    key={index}
                                    onClick={() => handleTabChange(index)}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        py: 1,
                                        px: 2,
                                        borderRadius: '20px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        backgroundColor: activeTab === index ? '#1E7C88' : '#f8f9fa',
                                        color: activeTab === index ? '#fff' : '#666',
                                        fontSize: '0.875rem',
                                        fontWeight: activeTab === index ? 600 : 500,
                                        boxShadow: activeTab === index ? '0 2px 8px rgba(30, 124, 136, 0.2)' : 'none',
                                        border: activeTab === index ? '1px solid #1E7C88' : '1px solid #e9ecef',
                                        minWidth: 'fit-content',
                                        '&:hover': {
                                            backgroundColor: activeTab === index ? '#176B75' : '#e9ecef',
                                            transform: 'translateY(-1px)'
                                        }
                                    }}
                                >
                                    {tab.icon && <img src={tab.icon} alt={tab.label} style={{ width: '16px', height: '16px' }} />}
                                    {tab.label}
                                    <Box
                                        sx={{
                                            minWidth: 20,
                                            height: 20,
                                            borderRadius: '10px',
                                            backgroundColor: activeTab === index ? 'rgba(255, 255, 255, 0.2)' : '#e8f5e8',
                                            color: activeTab === index ? '#fff' : '#2e7d32',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '0.75rem',
                                            fontWeight: 600,
                                            border: activeTab === index ? '1px solid rgba(255, 255, 255, 0.3)' : '1px solid #d4edda'
                                        }}
                                    >
                                        {tab.count}
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Box>

                    {/* User List */}
                    <Box sx={{ p: 2, maxHeight: '400px', overflowY: 'auto' }}>
                        {isLoading ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    py: 4
                                }}
                            >
                                <Typography>Loading...</Typography>
                            </Box>
                        ) : currentUsers.length > 0 ? (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                {currentUsers.map((userReaction, index) => (
                                    <UserCard key={index} userReaction={userReaction} />
                                ))}
                            </Box>
                        ) : (
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    py: 4,
                                    textAlign: 'center'
                                }}
                            >
                                <Typography variant="h6" sx={{ color: '#666', mb: 1 }}>
                                    No reactions yet
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#999' }}>
                                    Be the first to react to this post!
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </DialogContent>
            </Dialog>

            {viewProfile && (
                <Dialog
                    open={viewProfile}
                    onClose={() => setViewProfile(false)}
                    maxWidth="md"
                    fullWidth
                    PaperProps={{
                        sx: {
                            borderRadius: '12px',
                            maxHeight: '90vh',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            border: '1px solid #e9ecef'
                        }
                    }}
                >
                    <ReactViewProfile setViewProfile={setViewProfile} viewProfile={viewProfile} profileData={userProfileData} />
                </Dialog>
            )}
        </>
    );
};

export default ViewReactModal;
